var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Corrosion.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Corrosion.text,
      "bgImage": "/images/sub/product/corrosion-bg.jpg",
      "image": "/images/sub/product/corrosion-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" In the field of corrosion measurement, control, and prevention, various technical activities are used to manage the different corrosion causes and effects on materials and structures. These activities can be applied differently depending on the corrosion causes and the types of materials or structures involved. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Within the sphere of corrosion control and prevention, there are technical options such as cathodic and anodic protection, materials selection, chemical dosing and the application of internal and external coatings. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Corrosion measurement employs a variety of techniques to determine how corrosive the environment is and at what rate metal loss is being experienced. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" Corrosion measurement is the quantitative method by which the effectiveness of corrosion control and prevention techniques can be evaluated and provides the feedback to enable corrosion control and prevention methods to be optimized. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }